export const FETCH_ACCOUNTS = 'ye/accounts/FETCH_ACCOUNTS';
export const FETCH_ACCOUNTS_SUCCESS = 'ye/accounts/FETCH_ACCOUNTS_SUCCESS';
export const FETCH_ACCOUNTS_ERROR = 'ye/accounts/FETCH_ACCOUNTS_ERROR';
export const LOAD_ACCOUNTS_DETAIL = 'ye/accounts/LOAD_ACCOUNTS_DETAIL';
export const ACCOUNTS_DETAIL_ERROR = 'ye/accounts/ACCOUNTS_DETAIL_ERROR';
export const ACCOUNTS_UNMOUNT_DETAIL = 'ye/accounts/ACCOUNTS_UNMOUNT_DETAIL';
export const ACCOUNTS_DETAIL_DATA = 'ye/accounts/ACCOUNTS_DETAIL_DATA;';
export const FETCH_ACCOUNT_SETTINGS = 'ye/accounts/FETCH_ACCOUNT_SETTINGS';
export const FETCH_ACCOUNT_SETTINGS_SUCCESS = 'ye/accounts/FETCH_SETTINGS_SUCCESS';
export const FETCH_ACCOUNT_SETTINGS_ERROR = 'ye/accounts/FETCH_SETTINGS_ERROR';
export const UPDATE_ACCOUNT_GENERAL_SETTINGS = 'ye/accounts/UPDATE_ACCOUNT_GENERAL_SETTINGS';
export const UPDATE_ACCOUNT_GENERAL_SETTINGS_SUCCESS =
    'ye/accounts/UPDATE_ACCOUNT_GENERAL_SETTINGS_SUCCESS';
export const UPDATE_ACCOUNT_GENERAL_SETTINGS_ERROR = 'ye/accounts/UPDATE_ACCOUNT_GENERAL_SETTINGS_ERROR';
export const REGISTER_USER = 'ye/accounts/REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'ye/accounts/REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'ye/accounts/REGISTER_USER_ERROR';

// Account Invoices
export const FETCH_ACCOUNT_INVOICES = 'ye/accounts/FETCH_ACCOUNT_INVOICES';
export const FETCH_ACCOUNT_INVOICES_SUCCESS = 'ye/accounts/FETCH_ACCOUNT_INVOICES_SUCCESS';
export const FETCH_ACCOUNT_INVOICES_ERROR = 'ye/accounts/FETCH_ACCOUNT_INVOICES_ERROR';
